import * as yup from "yup";

const operatorAddressScheme = yup.object().shape({
  addressLine1: yup.string().required("Address is required"),
  stateCode: yup.string().required("State is required"),
  city: yup.string().required("City is required"),
  postalCode: yup
    .string()
    .matches(/^\d{5}$/, "Invalid ZIP code")
    .required("ZIP is required"),
});

export default operatorAddressScheme;
